/* CANIPANI — galerie produit.
 *
 * Le rail glisse au doigt sur mobile : c'est le geste attendu, et le
 * défilement natif évite d'embarquer une bibliothèque pour trois lignes de
 * logique. Les points et les vignettes ne font que déplacer le rail ; un
 * observateur remet l'état à jour quand l'utilisateur fait glisser lui-même.
 */
(function () {
  var galeries = document.querySelectorAll('[data-gallery]');

  Array.prototype.forEach.call(galeries, function (g) {
    var rail = g.querySelector('[data-gallery-rail]');
    if (!rail) return;

    var vues = g.querySelectorAll('[data-gallery-vue]');
    var points = g.querySelectorAll('.gallery__point');
    var vignettes = g.querySelectorAll('.gallery__thumb');
    if (vues.length < 2) return;

    function activer(i) {
      Array.prototype.forEach.call(points, function (p, n) {
        p.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      Array.prototype.forEach.call(vignettes, function (v, n) {
        v.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function aller(i) {
      var v = vues[i];
      if (!v) return;
      rail.scrollTo({ left: v.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      activer(i);
    }

    function brancher(el) {
      el.addEventListener('click', function () {
        aller(parseInt(el.getAttribute('data-index'), 10) || 0);
      });
    }
    Array.prototype.forEach.call(points, brancher);
    Array.prototype.forEach.call(vignettes, brancher);

    if (!('IntersectionObserver' in window)) return;

    var suivi = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          activer(parseInt(e.target.getAttribute('data-index'), 10) || 0);
        }
      });
    }, { root: rail, threshold: [0.6] });

    Array.prototype.forEach.call(vues, function (v) { suivi.observe(v); });
  });
})();
